// Bangladeshi mobile numbers: 11 digits starting 01[3-9], optionally
// prefixed with the country code (+880 or 880). Spaces/dashes typed for
// readability (e.g. "01684 129 335") are tolerated but stripped before
// the value is stored, mirroring the backend rule in
// app/Rules/BangladeshiPhoneNumber.php.
const BD_PHONE_REGEX = /^(?:\+?880|0)1[3-9]\d{8}$/;

export const normalizeBdPhone = (value) => (value ? value.replace(/[\s-]/g, '') : value);

export const isValidBdPhone = (value) => BD_PHONE_REGEX.test(normalizeBdPhone(value) || '');

/** antd Form.Item rule — pair with `{ required: true }` for the empty case. */
export const bdPhoneRule = {
  validator: (_, value) => {
    if (!value) return Promise.resolve();
    if (isValidBdPhone(value)) return Promise.resolve();
    return Promise.reject(new Error('Enter a valid Bangladeshi phone number, e.g. 01712 345 678'));
  },
};
